<template>
  <div class="main-wrapper">
    <!-- <div id="nav">
      <router-link to="/">Home</router-link> |
      <router-link to="/about">About</router-link>
    </div>
     -->
    <loader></loader>
    <main-header />
    <main-search-bar />
    <slot></slot>
    <main-footer />


    
  </div>
</template>

<script>
import MainHeader from '@/components/Header.vue';
import MainFooter from '@/components/Footer.vue';
import MainSearchBar from '../components/MainSearchBar.vue';
export default {
  name: "Default",
  components: {
    MainHeader,
    MainFooter,
    MainSearchBar
  },
}
</script>
